// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
// import { isMobile } from "@/util.js";

Vue.use(Vant);
Vue.use(Lazyload);


Vue.config.productionTip = false

// const isPhone = isMobile();//true-移动端，false-PC端
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }

//   //由于新版本M832页面不支持手机端，所以判断手机端展示老版本，PC端展示新版本---已经调整适配手机端，注释掉此段
//   // if (to.path === '/m832' && isPhone) {
//   //   next({ name: 'M832_old' })
//   // } else if (to.path === '/m832_old' && !isPhone) {
//   //   next({ name: 'M832' })
//   // } else
//   next()
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js